// extracted by mini-css-extract-plugin
export default {"breadcrumb":"styles__breadcrumb__vh90B"};